module.exports = __webpack_public_path__ + "img/error-credit.7cf4b1cc.svg";